module.exports = __webpack_public_path__ + "r1-4dfae412.webp";